/* eslint react/no-direct-mutation-state: "off",'no-redeclare': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Label, Row, Form, Modal } from 'reactstrap';
import '../../../../../Assets/EnsembleStyles/AddRequest_Modal.css';
import { GetAllTenantList, GetZonesListforTenant, GetCalculateCost } from '../../../../../action/tenantAction';
import { SaveRequest, GetSelectedRequest, UpdateRequest, GetSelectedPastRequest } from '../../../../../action/requestAction';
import { connect } from "react-redux";
import DatePicker from 'react-datepicker';
import moment from 'moment';
// import MuiTimePicker from 'material-ui/TimePicker'
import TimeKeeper from 'react-timekeeper';
import 'react-datepicker/dist/react-datepicker.css';
import TimeString from '../../../../../Resources/Conversions';
import { setAmplitudeEvent } from 'amplitude/amplitude';


class AddRequest extends Component {

    async componentDidMount() {
        const l_Tenants = this.props.GetAllTenantList();
        const l_Zones = this.props.GetZonesListforTenant(this.props.DefaultId);
        const l_Request = this.props.IsPastRequest ? this.props.GetSelectedPastRequest(this.props.RequestId) : this.props.GetSelectedRequest(this.props.RequestId);

        await Promise.all([l_Tenants, l_Zones, l_Request]);

        let l_StartDate = this.GetLocalTime();
        let l_EndDate = this.GetLocalTimeWithMinimumBillAmount();
        this.setState({
            defaultDate: l_StartDate,
            startDate: l_StartDate,
            stopDate: l_EndDate,
            startTime: l_StartDate.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
            SelectedStartTime: l_StartDate.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
            stopTime: l_EndDate.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
            SelectedEndTime: l_EndDate.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
            TenantId: this.props.DefaultId,
            RequestId: this.props.RequestId,
            ZoneName: this.props.ZoneName,
            TenantName: this.props.TenantName,
            IsActiveRequest: false,
            IsLoading: true,
            IsInActiveRequest: false
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            defaultDate: new Date(),
            startDate: new Date(),
            stopDate: new Date(),
            startTime: new Date().toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),            
            stopTime: new Date().toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
            isSingleRequest: true,
            modal: false,
            IsErrorWithCurrent: false,
            IsErrorWithStartTime: false,
            RequestId: 0,
            ZoneId: 0,
            TenantId: 0,
            ZoneName: '',
            TenantName: '',
            request_status: '',
            request_created: '',
            IsLoading: false,
            IsInActiveRequest: false,
            IsRepeatError: false,
            ShowStTime: false,
            ShowEndTime: false,
            SelectedStartTime: "00:00",
            SelectedEndTime: "00:00"
        }


        this.LoadTenantZones = this.LoadTenantZones.bind(this);
        this.OnSaveRequest = this.OnSaveRequest.bind(this);
        this.OnUpdateRequest = this.OnUpdateRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleStopDateChange = this.handleStopDateChange.bind(this);
        this.ChangeZones = this.ChangeZones.bind(this);
        // this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
        // this.handleStopTimeChange = this.handleStopTimeChange.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.OnGetCaluculateCost = this.OnGetCaluculateCost.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    LoadTenantZones() {
        var selectedoption = this.refs.Tenants_in_Select_input.options.selectedIndex;
        const tenantID = this.refs.Tenants_in_Select_input.options[selectedoption].id;
        this.state.TenantName = this.refs.Tenants_in_Select_input.options[selectedoption].value;
        const actionResponse = this.props.GetZonesListforTenant(tenantID);
        actionResponse.then((result) => {
            let l_StartDate = this.GetLocalTime();
            let l_EndDate = this.GetLocalTimeWithMinimumBillAmount();
            this.setState({
                defaultDate: l_StartDate,
                startDate: l_StartDate,
                stopDate: l_EndDate,
                startTime: l_StartDate.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
                SelectedStartTime: l_StartDate.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
                stopTime: l_EndDate.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
                SelectedEndTime: l_EndDate.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
            });
        })
    }

    toggle(e) {
        e.preventDefault();
        this.setState({
            modal: !this.state.modal,
            IsErrorWithCurrent: false,
            IsErrorWithStartTime: false
        });
    }

    GetLocalTime = () => {
        var localTime = new Date();
        var utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
        var selectedoption = this.refs.Zones_in_Select_input.options.selectedIndex;
        var zoneOffset = (this.refs.Zones_in_Select_input.options[selectedoption] != undefined) ? this.refs.Zones_in_Select_input.options[selectedoption].getAttribute('timezone') : 0;
        // create new Date object for different city using supplied offset
        var zonetime = new Date(utc + (3600000 * zoneOffset));
        return zonetime;
    }

    FormValidDate = (date) => {
        return (date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":00")
    }

    ValidateDate = (frmDate, toDate, endate) => {
        if(this.props.RequestId > 0 && this.props.IsPastRequest) {
            return (frmDate <= endate) ? true : false;
        }
        else if (this.props.RequestId > 0 && this.state.IsActiveRequest) {
            return (endate > toDate) ? true : false;
        }
        else {
            return (frmDate >= toDate) ? true : false;
        }
    }

    GetLocalTimeWithMinimumBillAmount = () => {
        var selectedoption = this.refs.Tenants_in_Select_input.options.selectedIndex;
        var minBillAmount = (this.refs.Tenants_in_Select_input.options[selectedoption] != undefined) ? this.refs.Tenants_in_Select_input.options[selectedoption].getAttribute('minBillAmount') : 0;
        return new Date(this.GetLocalTime().getTime() + ((minBillAmount * 60) * 60000));
    }

    ChangeZones(e) {
        var localTime = new Date();
        var utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
        var selectedoption = this.refs.Zones_in_Select_input.options.selectedIndex;
        var zoneOffset = this.refs.Zones_in_Select_input.options[selectedoption].getAttribute('timezone');
        this.state.ZoneName = this.refs.Zones_in_Select_input.options[selectedoption].value;
        var selectedoption = this.refs.Tenants_in_Select_input.options.selectedIndex;
        var minBillAmount = this.refs.Tenants_in_Select_input.options[selectedoption].getAttribute('minBillAmount');
        // create new Date object for different city using supplied offset
        var zonetime = new Date(utc + (3600000 * zoneOffset));
        var Endtime = new Date(zonetime.getTime() + ((minBillAmount * 60) * 60000));

        this.setState({
            defaultDate: zonetime,
            startDate: zonetime,
            stopDate: Endtime,
            startTime: zonetime.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
            SelectedStartTime: zonetime.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
            stopTime: Endtime.toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(),
            SelectedEndTime: Endtime.toLocaleTimeString([], {timeStyle: 'short', hour12: false}),
            IsErrorWithCurrent: false,
            IsErrorWithStartTime: false
        });
    }

    handleChange(date) {
        this.setState({
            startDate: date,
            stopDate: date
        });
    }

    handleStopDateChange(date) {
        this.setState({
            stopDate: date
        });
    }

    // handleStartTimeChange(event, time) {
    //     this.setState({
    //         startTime: time,
    //         IsErrorWithCurrent: false
    //     });
    // }

    // handleStopTimeChange(event, time) {
    //     this.setState({
    //         stopTime: time,
    //         IsErrorWithStartTime: false
    //     });
    // }

    handleRadio() {
        if (this.refs.SingleRequest.checked) {
            this.setState({ isSingleRequest: true });
        } else {
            this.setState({ isSingleRequest: false });
        }
    }

    handleOnBlur(e) {
        let m = moment(e.target.value);
        console.log(m + ", " + moment());
        if (m.isValid() && m >= moment()) {
            console.log(e.target.value)
        }
        else {
            this.setState({
                startDate: new Date()
            });
        }
    }

    OnUpdateRequest(e) {

    }

    OnSaveRequest(e) {
        this.setState({ IsRepeatError: false });
        var tenantselectedoption = this.refs.Tenants_in_Select_input.options.selectedIndex;
        var zoneselectedoption = this.refs.Zones_in_Select_input.options.selectedIndex;

        if (this.refs.Tenants_in_Select_input.options.length > 0 && this.refs.Zones_in_Select_input.options.length > 0) {
            let EndDateTime, StartDateTime, CurrentDateTime;
            let recuringDays = [];
            let TenantId = this.refs.Tenants_in_Select_input.options[tenantselectedoption].id;
            let ZoneId = this.refs.Zones_in_Select_input.options[zoneselectedoption].id;
            StartDateTime = this.state.startDate.getFullYear() + "/" + (this.state.startDate.getMonth() + 1) + "/" + this.state.startDate.getDate() + " " + this.state.SelectedStartTime + ":00";

            if (this.state.isSingleRequest) {
                EndDateTime = this.state.stopDate.getFullYear() + "/" + (this.state.stopDate.getMonth() + 1) + "/" + this.state.stopDate.getDate() + " " + this.state.SelectedEndTime + ":00";
            }
            else {
                let twoDigitMonth = (this.state.stopDate.getMonth() + 1).toString().length > 1 ? (this.state.stopDate.getMonth() + 1) : "0" + (this.state.stopDate.getMonth() + 1).toString();
                let twoDigitDay = this.state.stopDate.getDate().toString().length > 1 ? this.state.stopDate.getDate() : "0" + this.state.stopDate.getDate().toString();

                EndDateTime = twoDigitDay + "/" + twoDigitMonth + "/" + this.state.startDate.getFullYear();
                if (this.refs.recur_Monday.checked) {
                    recuringDays.push("1");
                }
                if (this.refs.recur_Tuesday.checked) {
                    recuringDays.push("2");
                }
                if (this.refs.recur_Wednesday.checked) {
                    recuringDays.push("3");
                }
                if (this.refs.recur_Thursday.checked) {
                    recuringDays.push("4");
                }
                if (this.refs.recur_Friday.checked) {
                    recuringDays.push("5");
                }
                if (this.refs.recur_Saturday.checked) {
                    recuringDays.push("6");
                }
                if (this.refs.recur_Sunday.checked) {
                    recuringDays.push("0");
                }
            }

            let RecurEndTime = this.state.stopDate.getFullYear() + "/" + (this.state.stopDate.getMonth() + 1) + "/" + this.state.stopDate.getDate() + " " + this.state.SelectedEndTime + ":00";
            let Comments = this.refs.Comments.value;
            let IsValid = true;
            if (!this.state.isSingleRequest) {
                if (recuringDays.length <= 0)
                    IsValid = false;
                else {
                    let l_startdate = new Date(StartDateTime);
                    let l_enddate = new Date(RecurEndTime);

                    let l_tempdate = l_startdate;
                    let l_daysinrange = [];

                    while (l_tempdate <= l_enddate) {
                        var l_day = l_tempdate.getDay();
                        if (l_daysinrange.indexOf(l_day) === -1) {
                            l_daysinrange.push(l_day);
                        }
                        l_tempdate = new Date(l_tempdate.setDate(l_tempdate.getDate() + 1));
                    }
                    var i = 0;
                    var l_range = l_daysinrange.toString();
                    IsValid = false;
                    while (i < recuringDays.length) {
                        var arr = recuringDays[i];
                        if (l_range.indexOf(arr) !== -1) {
                            IsValid = true;
                        }
                        i++;
                    }
                }
            }

            if (new Date(StartDateTime) < new Date(this.state.isSingleRequest ? EndDateTime : RecurEndTime) && IsValid) {
                var startDate = new Date(StartDateTime)  //eslint-disable-line
                var stopDate = this.GetLocalTime()
                CurrentDateTime = stopDate.getFullYear() + "/" + (stopDate.getMonth() + 1) + "/" + stopDate.getDate() + " " + stopDate.getHours() + ":" + stopDate.getMinutes() + ":00";
                if (this.ValidateDate(new Date(StartDateTime), new Date(CurrentDateTime), new Date(this.state.isSingleRequest ? EndDateTime : RecurEndTime))) {
                    const eventProperties = { "Selected UI option": "Calendar" }
                    if (this.state.isSingleRequest) {
                        var Request = {
                            "StartDateTime": StartDateTime,
                            "EndDateTime": EndDateTime,
                            "IsRepeat": !this.state.isSingleRequest,
                            "TenantId": TenantId,
                            "ZoneId": ZoneId,
                            "Comment": Comments,
                            "RequestId": parseInt(this.props.RequestId)
                        }
                        eventProperties["Repeating Request"] = false;
                    }
                    else {
                        var Request = {
                            "StartDateTime": StartDateTime,
                            "EndDateTime": RecurEndTime,
                            "IsRepeat": !this.state.isSingleRequest,
                            "TenantId": TenantId,
                            "ZoneId": ZoneId,
                            "Comment": Comments,
                            "RecurDays": recuringDays,
                            "RecurTime": EndDateTime,
                            "RequestId": parseInt(this.props.RequestId)
                        }
                        eventProperties["Repeating Request"] = true;

                    }

                    if (this.props.RequestId > 0) {
                        setAmplitudeEvent("Edit After Hours Request", { "Selected UI option": "Calendar" });

                        this.props.UpdateRequest(Request);
                    }
                    else {
                        setAmplitudeEvent("New After Hours Request", eventProperties);
                        this.props.SaveRequest(Request);
                    }
                    this.props.CloseModal2(e.target.value);
                }
                else {
                    this.setState({
                        IsErrorWithCurrent: true
                    });
                }
            }
            else {
                if (!IsValid) {
                    this.setState({ IsRepeatError: true });
                } else {
                    this.setState({
                        IsErrorWithStartTime: true
                    });
                }
            }
        }
    }

    OnGetCaluculateCost() {

        var tenantselectedoption = this.refs.Tenants_in_Select_input.options.selectedIndex;
        var zoneselectedoption = this.refs.Zones_in_Select_input.options.selectedIndex;

        if (this.refs.Tenants_in_Select_input.options.length > 0 && this.refs.Zones_in_Select_input.options.length > 0) {
            let EndDateTime, StartDateTime, CurrentDateTime;
            let recuringDays = [];
            let TenantId = this.refs.Tenants_in_Select_input.options[tenantselectedoption].id;
            let ZoneId = this.refs.Zones_in_Select_input.options[zoneselectedoption].id;
            // StartDateTime = this.state.startDate.getFullYear() + "/" + (this.state.startDate.getMonth() + 1) + "/" + this.state.startDate.getDate() + " " + this.state.startTime.getHours() + ":" + this.state.startTime.getMinutes() + ":00";
            StartDateTime = this.state.startDate.getFullYear() + "/" + (this.state.startDate.getMonth() + 1) + "/" + this.state.startDate.getDate() + " " + this.state.SelectedStartTime + ":00";

            if (this.state.isSingleRequest) {
                // EndDateTime = this.state.stopDate.getFullYear() + "/" + (this.state.stopDate.getMonth() + 1) + "/" + this.state.stopDate.getDate() + " " + this.state.stopTime.getHours() + ":" + this.state.stopTime.getMinutes() + ":00";
                EndDateTime = this.state.stopDate.getFullYear() + "/" + (this.state.stopDate.getMonth() + 1) + "/" + this.state.stopDate.getDate() + " " + this.state.SelectedEndTime + ":00";
            }
            else {
                let twoDigitMonth = (this.state.stopDate.getMonth() + 1).toString().length > 1 ? (this.state.stopDate.getMonth() + 1) : "0" + (this.state.stopDate.getMonth() + 1).toString();
                let twoDigitDay = this.state.stopDate.getDate().toString().length > 1 ? this.state.stopDate.getDate() : "0" + this.state.stopDate.getDate().toString();

                EndDateTime = twoDigitDay + "/" + twoDigitMonth + "/" + this.state.startDate.getFullYear();
                if (this.refs.recur_Monday.checked) {
                    recuringDays.push("1");
                }
                if (this.refs.recur_Tuesday.checked) {
                    recuringDays.push("2");
                }
                if (this.refs.recur_Wednesday.checked) {
                    recuringDays.push("3");
                }
                if (this.refs.recur_Thursday.checked) {
                    recuringDays.push("4");
                }
                if (this.refs.recur_Friday.checked) {
                    recuringDays.push("5");
                }
                if (this.refs.recur_Saturday.checked) {
                    recuringDays.push("6");
                }
                if (this.refs.recur_Sunday.checked) {
                    recuringDays.push("0");
                }
            }

            let RecurEndTime = this.state.stopDate.getFullYear() + "/" + (this.state.stopDate.getMonth() + 1) + "/" + this.state.stopDate.getDate() + " " + this.state.SelectedEndTime + ":00";
            let Comments = this.refs.Comments.value;

            if (new Date(StartDateTime) < new Date(this.state.isSingleRequest ? EndDateTime : RecurEndTime)) {
                var startDate = new Date(StartDateTime)  //eslint-disable-line
                var stopDate = this.GetLocalTime()
                CurrentDateTime = stopDate.getFullYear() + "/" + (stopDate.getMonth() + 1) + "/" + stopDate.getDate() + " " + stopDate.getHours() + ":" + stopDate.getMinutes() + ":00";

                if (this.ValidateDate(new Date(StartDateTime), new Date(CurrentDateTime), new Date(this.state.isSingleRequest ? EndDateTime : RecurEndTime))) {
                    if (this.state.isSingleRequest) {
                        var Request = {
                            "StartDateTime": StartDateTime,
                            "EndDateTime": EndDateTime,
                            "IsRepeat": !this.state.isSingleRequest,
                            "TenantId": TenantId,
                            "ZoneId": ZoneId,
                            "Comment": Comments
                        }
                    }
                    else {
                        var Request = {
                            "StartDateTime": StartDateTime,
                            "EndDateTime": RecurEndTime,
                            "IsRepeat": !this.state.isSingleRequest,
                            "TenantId": TenantId,
                            "ZoneId": ZoneId,
                            "Comment": Comments,
                            "RecurDays": recuringDays,
                            "RecurTime": EndDateTime
                        }
                    }
                    this.props.GetCalculateCost(Request);
                    this.setState({
                        modal: !this.state.modal
                    });
                }
                else {
                    this.setState({
                        IsErrorWithCurrent: true
                    });
                }
            }
            else {
                this.setState({
                    IsErrorWithStartTime: true
                });
            }
        }
    }

    render(Tenant_List_Response, Tenant_ZoneList_Response, Tenant_Request_Cost, Request_Selected_Response, getLabels) {
        var CloseModal = this.props.CloseModal;
        let Tenants_in_Select_input = null, Zones_in_Select_input = null, Cost_in_input = '', errorCurrentTime = null, errorStartTime = null, current_Day = null, errorRecur = null;
        let l_Comments = '', is_Active_Request = false, l_DisableControls = false, l_Header = '';
        let l_IsPastRequest = this.props.IsPastRequest;
        let label = this.props.getLabels;
        this.state.IsActiveRequest = false;



        if (this.props.RequestId > 0 && this.props.Request_Selected_Response.SelectedRequest.length != [] && this.state.IsLoading) {
            this.state.startDate = new Date(TimeString.GetDateString(this.props.Request_Selected_Response.SelectedRequest.startDateTime));
            this.state.SelectedStartTime = new Date("0001/01/01 " + TimeString.GetTimeString(this.props.Request_Selected_Response.SelectedRequest.startDateTime)).toLocaleTimeString([], {timeStyle: 'short', hour12: false});
            this.state.startTime = new Date("0001/01/01 " + TimeString.GetTimeString(this.props.Request_Selected_Response.SelectedRequest.startDateTime)).toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(); //new Date(this.props.Request_Selected_Response.SelectedRequest.startDateTime);
            this.state.stopDate = new Date(TimeString.GetDateString(this.props.Request_Selected_Response.SelectedRequest.stopDateTime));
            this.state.SelectedEndTime = new Date("0001/01/01 " + TimeString.GetTimeString(this.props.Request_Selected_Response.SelectedRequest.stopDateTime)).toLocaleTimeString([], {timeStyle: 'short', hour12: false}); 
            this.state.stopTime = new Date("0001/01/01 " + TimeString.GetTimeString(this.props.Request_Selected_Response.SelectedRequest.stopDateTime)).toLocaleTimeString([], {timeStyle: 'short'}).toLowerCase(); //new Date(this.props.Request_Selected_Response.SelectedRequest.stopDateTime);
            l_Comments = this.props.Request_Selected_Response.SelectedRequest.requestComment
            this.state.IsLoading = false;
            if (this.props.Request_Selected_Response.SelectedRequest.status == 4) {
                this.state.IsInActiveRequest = true;
            }
            else {
                this.state.IsInActiveRequest = false;
            }
            if(l_IsPastRequest)
                this.state.request_status = "Past Request";
            else
                this.state.request_status = (this.props.Request_Selected_Response.SelectedRequest.status === 0) ? "Future Request" : (this.props.Request_Selected_Response.SelectedRequest.status === 1) ? "In Progress" : "Redundant Request";
            this.state.request_created = this.props.Request_Selected_Response.SelectedRequest.createdBy + " | " + new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(this.props.Request_Selected_Response.SelectedRequest.createdDateTime));
        }

        current_Day = this.state.startDate.getDay();
        if (this.state.IsRepeatError) {
            errorRecur = <p className="validation_error_msg" style={{ "padding-top": "12px" }}>
                Recurrence Pattern not Valid. Selected Days Not in Date Range.
            </p>
        }

        if (this.state.IsErrorWithCurrent) {
            errorCurrentTime = <p className="validation_error_msg">
                {label['AfterHours.HigerThanCurrentTime.Text'] !== undefined ? label['AfterHours.HigerThanCurrentTime.Text'] : "Please select Higher than the Current Time"}
            </p>
        }
        else if (this.state.IsErrorWithStartTime) {
            errorStartTime = <p className="validation_error_msg">
                {label['AfterHours.HigerThanStartTime.Text'] !== undefined ? label['AfterHours.HigerThanStartTime.Text'] : "Please select Higher than the Start Time"}
            </p>
        }

        if (this.props.Tenant_Request_Cost.Cost != undefined && this.props.Tenant_Request_Cost.Cost.data != undefined) {
            var CostDetail = null;
            CostDetail = this.props.Tenant_Request_Cost.Cost.data;

            if (CostDetail != null) {
                let CurrencySymb = CostDetail.cost.currency, l_Note = '', l_Star = '';
                if (CostDetail.cost.minimumHoursApplied) {
                    l_Note = '*The minimum cost per request has been applied.'
                    l_Star = '*'
                }
                Cost_in_input = <Form style={{ width: '600px' }}>
                    <FormGroup row>
                        <Col sm={8}>
                            <Label className="mdl-DialogHeader">{label['AfterHours.MailBodyRequestCost.Text'] !== undefined ? label['AfterHours.MailBodyRequestCost.Text'] : "Estimated Cost"}</Label>
                        </Col>
                        <Col sm={4} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogHeader">{CurrencySymb}{' '}{CostDetail.cost.displayTotalAmount}{l_Star}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={9}>
                            <Label className="mdl-DialogContent">{label['AfterHours.RequestsCreated.Text'] !== undefined ? label['AfterHours.RequestsCreated.Text'] : "Requests to be created"}</Label>
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent">{CostDetail.cost.noOfRequests}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={9}>
                            <Label className="mdl-DialogContent">{label['AfterHours.TotalHoursRequested.Text'] !== undefined ? label['AfterHours.TotalHoursRequested.Text'] : "Total hours requested"}</Label>
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent" >{CostDetail.totalHours.toFixed(2)}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={8}>
                            <Label className="mdl-DialogContent">{label['CreateTenant.AfterHoursHourlyRate.Text'] !== undefined ? label['CreateTenant.AfterHoursHourlyRate.Text'] : "Cost per Hour*"}</Label>
                        </Col>
                        <Col sm={4} style={{ textAlign: 'right' }}>
                            <Label className="mdl-DialogContent">{CurrencySymb}{' '}{CostDetail.cost.amountPerHour}</Label>
                        </Col>
                    </FormGroup>
                    {CostDetail.cost.minimumHoursApplied ? (
                        <FormGroup row>
                            <Col sm={12}>
                                <Label style={{ paddingLeft: '16px' }}>{l_Note}</Label>
                            </Col>
                        </FormGroup>) : ('')
                    }
                    <FormGroup row>
                        <Col sm={9}>
                            {' '}
                        </Col>
                        <Col sm={3} style={{ textAlign: 'right' }}>
                            <input type="submit" className="btn btn-link mdl-DialogContent" style={{ color: 'black' }} value="close" onClick={this.toggle} />
                        </Col>
                    </FormGroup>

                </Form>
            }
        }

        if (this.props.Tenant_List_Response != undefined && this.props.Tenant_List_Response.TenantNameList != undefined && this.props.Tenant_List_Response.TenantNameList != null) {
            var data = this.props.Tenant_List_Response.TenantNameList.filter(el => el.isWorkOrder !== true);
            Tenants_in_Select_input = data.map(el => (
                <option id={el.tenantId} key={el.tenantId} minBillAmount={el.minmumAfterHour === null ? "" : el.minmumAfterHour}>{el.tenantName}</option>
            ));
        }

        if (this.props.Tenant_ZoneList_Response != undefined && this.props.Tenant_ZoneList_Response.TenantZones != undefined) {
            Zones_in_Select_input = this.props.Tenant_ZoneList_Response.TenantZones.map(el => (
                <option id={el.zoneId} key={el.zoneId} timezone={el.timeZoneOffset}>{el.zoneName}</option>
            ));
        }

        if (this.props.RequestId > 0 && this.refs.Zones_in_Select_input != undefined) {
            if (this.props.Request_Selected_Response !== undefined && this.props.Request_Selected_Response.SelectedRequest !== undefined) {
                is_Active_Request = (this.props.Request_Selected_Response.SelectedRequest.status == 1) ? true : false;
                this.state.IsActiveRequest = is_Active_Request;
            }
        }

        l_DisableControls = (this.props.RequestId > 0 || l_IsPastRequest) ? true : false;
        l_Header = l_IsPastRequest ? "Past Request" : (this.props.RequestId > 0) ? "Edit Request" : "Add Request";

        return (
            <div>
                <h4 className="form_title  form_title_Addrequest_modal">{l_Header}</h4>

                <Form style={{ paddingLeft: '15px' }}>
                    {this.props.RequestId > 0 ?
                        <FormGroup>
                            <label className="padding_Form_Left" style={{ color: '#323232' }}>Status</label>
                            <p>{this.state.request_status}</p>
                        </FormGroup> : ""}
                    <FormGroup>
                        <Label className="padding_Form_Left" style={{ color: '#323232' }} >{label['Requests.Columns.Tenant.Text'] !== undefined ? label['Requests.Columns.Tenant.Text'] : "Tenant"}</Label>
                        <select ref='Tenants_in_Select_input' disabled={l_DisableControls} value={this.state.TenantName} onChange={this.LoadTenantZones} className="tenat_form_control tenat_form_control_Addrequest_modal" >
                            {Tenants_in_Select_input}
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label className="padding_Form_Left" style={{ color: '#323232' }} >{label['Requests.Columns.Place.Text'] !== undefined ? label['Requests.Columns.Place.Text'] : "Place"}</label>
                        <select ref='Zones_in_Select_input' value={this.state.ZoneName} disabled={l_DisableControls} onChange={this.ChangeZones} className="tenat_form_control tenat_form_control_Addrequest_modal" >
                            {Zones_in_Select_input}
                        </select>
                    </FormGroup>

                    <FormGroup tag="fieldset" row onClick={this.toggleRequestForm} >
                        <Col sm={12}>
                            {!(is_Active_Request || this.state.IsInActiveRequest || l_IsPastRequest) ? (
                                <div>
                                    <FormGroup check >
                                        <Label check>
                                            <input type="radio" ref="SingleRequest" name="rdRequestType" value="0" defaultChecked="true" onChange={this.handleRadio} />
                                            {' '}
                                            {label['Requests.SingleRequest.Text'] !== undefined ? label['Requests.SingleRequest.Text'] : "Single Request"}
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check>
                                        <Label check>
                                            <input type="radio" ref="RepeatedRequest" name="rdRequestType" value="1" onChange={this.handleRadio} />
                                            {' '}
                                            {label['Requests.RepeatingRequests.Text'] !== undefined ? label['Requests.RepeatingRequests.Text'] : "Repeating Requests"}
                                        </Label>
                                    </FormGroup>
                                </div>) : ('')
                            }
                        </Col>
                    </FormGroup>

                    {this.state.isSingleRequest ? (
                        <div>
                            <div className="tenat_form_group form-group tenant_form">
                                <Row>
                                    <Col sm={{ size: 6, }}>
                                        <label className="padding_Form_Left" style={{ color: '#323232' }} >{label['AfterHours.From.Text'] !== undefined ? label['AfterHours.From.Text'] : "From"}</label><br />
                                        <DatePicker className="bottomBorderTextBox" minDate={this.state.defaultDate} dateFormat="EEE MMM dd yyyy" selected={this.state.startDate} disabled={is_Active_Request || this.state.IsInActiveRequest || l_IsPastRequest} onChange={this.handleChange} />
                                    </Col>
                                    <Col sm={{ size: 6 }}>
                                        {/* <MuiTimePicker style={{ pickerHeaderColor: '#61AE34' }} pedantic={false} textFieldStyle={{ width: '100px', fontSize: '12px' }} value={this.state.startTime} className="bottomBorderTextBox" disabled={is_Active_Request || this.state.IsInActiveRequest} onChange={this.handleStartTimeChange} /> */}
                                        {this.state.ShowStTime && (
                                            <div className='TimeConatiner'>
                                            <TimeKeeper
                                                time={this.state.startTime}
                                                onChange={(newTime) => this.setState({ startTime : newTime.formatted12, SelectedStartTime : newTime.formatted24 })}
                                                onDoneClick={() => this.setState({ ShowStTime : false, IsErrorWithCurrent: false })}
                                                switchToMinuteOnHourSelect
                                            />
                                            </div>
                                        )}
                                        <div className='BottomBorderTimeContainer'>
                                            <input type="text" className="BottomBorderTimeTxt" disabled={is_Active_Request || this.state.IsInActiveRequest || l_IsPastRequest} value={this.state.startTime} onClick={() => this.setState({ ShowStTime : true })} />
                                        </div>
                                        {errorCurrentTime}
                                    </Col>
                                </Row>
                            </div>

                            <div className="tenat_form_group form-group tenant_form">
                                <Row>
                                    <Col sm={{ size: 6, }}>
                                        <label className="padding_Form_Left" style={{ color: '#323232' }} >{label['AfterHours.To.Text'] !== undefined ? label['AfterHours.To.Text'] : "To"} </label><br />
                                        <DatePicker className="bottomBorderTextBox" dateFormat="EEE MMM dd yyyy" minDate={this.state.startDate} selected={this.state.stopDate} disabled={this.state.IsInActiveRequest || l_IsPastRequest} onChange={this.handleStopDateChange} />
                                    </Col>
                                    <Col sm={{ size: 6 }}>
                                        {/* <MuiTimePicker value={this.state.stopTime} textFieldStyle={{ width: '100px', fontSize: '12px' }} className="bottomBorderTimeTextBox" disabled={this.state.IsInActiveRequest} onChange={this.handleStopTimeChange} /> */}
                                        {this.state.ShowEndTime && (
                                            <div className='TimeConatiner'>
                                            <TimeKeeper
                                                time={this.state.stopTime}
                                                onChange={(newTime) => this.setState({ stopTime : newTime.formatted12, SelectedEndTime : newTime.formatted24 })}
                                                onDoneClick={() => this.setState({ ShowEndTime : false, IsErrorWithStartTime: false })}
                                                switchToMinuteOnHourSelect
                                            />
                                            </div>
                                        )}
                                        <div className='BottomBorderTimeContainer'>
                                            <input type="text" className="BottomBorderTimeTxt" disabled={this.state.IsInActiveRequest || l_IsPastRequest} value={this.state.stopTime} onClick={() => this.setState({ ShowEndTime : true })} />
                                        </div>
                                        {errorStartTime}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ) : (

                            <div>
                                {errorRecur}
                                <div className="tenat_form_group form-group tenant_form">
                                    <Row>
                                        <Col sm={{ size: 6, }}>
                                            <label className="padding_Form_Left"  style={{ color: '#323232' }}>{label['AfterHours.From.Text'] !== undefined ? label['AfterHours.From.Text'] : "From"}</label>
                                            {/* <MuiTimePicker value={this.state.startTime} textFieldStyle={{ width: '100px', fontSize: '12px' }} className="bottomBorderTimeTextBox" onChange={this.handleStartTimeChange} /> */}
                                            {this.state.ShowStTime && (
                                            <div className='TimeConatiner'>
                                            <TimeKeeper
                                                time={this.state.startTime}
                                                onChange={(newTime) => this.setState({ startTime : newTime.formatted12, SelectedStartTime : newTime.formatted24 })}
                                                onDoneClick={() => this.setState({ ShowStTime : false, IsErrorWithCurrent: false })}
                                                switchToMinuteOnHourSelect
                                            />
                                            </div>
                                            )}
                                            <br/>
                                            <div className='BottomBorderTimeContainer'  style={{"height":"30px"}}>
                                                <input type="text" className="BottomBorderRepeatTimeTxt" value={this.state.startTime} onClick={() => this.setState({ ShowStTime : true })} />
                                            </div>
                                            {errorCurrentTime}
                                        </Col>
                                        <Col sm={{ size: 6 }}>
                                            <label className="padding_Form_Left"  style={{ color: '#323232' }}>{label['AfterHours.To.Text'] !== undefined ? label['AfterHours.To.Text'] : "To"} </label>
                                            {/* <MuiTimePicker value={this.state.stopTime} textFieldStyle={{ width: '100px', fontSize: '12px' }} className="bottomBorderTimeTextBox" onChange={this.handleStopTimeChange} /> */}
                                            {this.state.ShowEndTime && (
                                            <div className='TimeConatiner'>
                                            <TimeKeeper
                                                time={this.state.stopTime}
                                                onChange={(newTime) => this.setState({ stopTime : newTime.formatted12, SelectedEndTime : newTime.formatted24 })}
                                                onDoneClick={() => this.setState({ ShowEndTime : false, IsErrorWithStartTime: false })}
                                                switchToMinuteOnHourSelect
                                            />
                                            </div>
                                            )}
                                            <br/>
                                            <div className='BottomBorderTimeContainer' style={{"height":"30px"}}>
                                                <input type="text" className="BottomBorderRepeatTimeTxt" value={this.state.stopTime} onClick={() => this.setState({ ShowEndTime : true })} />
                                            </div>
                                            {errorStartTime}
                                        </Col>
                                    </Row>

                                    <FormGroup style={{"padding-top":"10px"}}>
                                        <label className="padding_Form_Left" style={{ color: '#323232' }}>{label['Requests.RepeatStarting.Text'] !== undefined ? label['Requests.RepeatStarting.Text'] : "Repeat Starting"}</label><br />
                                        <DatePicker className="bottomBorderTextBox" dateFormat="EEE MMM dd yyyy" minDate={this.state.defaultDate} selected={this.state.startDate} onChange={this.handleChange} />
                                    </FormGroup>

                                    <FormGroup>
                                        <label className="padding_Form_Left" style={{ color: '#323232' }}>{label['Requests.RepeatOn.Text'] !== undefined ? label['Requests.RepeatOn.Text'] : "Repeat On"}</label>
                                    </FormGroup>

                                    <Row>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="1" defaultChecked={current_Day == 1 ? true : false} ref="recur_Monday" /> {label['CreateTenant.Monday.Text'] !== undefined ? label['CreateTenant.Monday.Text'] : "Monday"}
                                        </Col>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="2" defaultChecked={current_Day == 2 ? true : false} ref="recur_Tuesday" /> {label['CreateTenant.Tuesday.Text'] !== undefined ? label['CreateTenant.Tuesday.Text'] : "Tuesday"}
                                        </Col>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="3" defaultChecked={current_Day == 3 ? true : false} ref="recur_Wednesday" /> {label['CreateTenant.Wednesday.Text'] !== undefined ? label['CreateTenant.Wednesday.Text'] : "Wednesday"}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="4" defaultChecked={current_Day == 4 ? true : false} ref="recur_Thursday" /> {label['CreateTenant.Thursday.Text'] !== undefined ? label['CreateTenant.Thursday.Text'] : "Thursday"}
                                        </Col>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="5" defaultChecked={current_Day == 5 ? true : false} ref="recur_Friday" />{label['CreateTenant.Friday.Text'] !== undefined ? label['CreateTenant.Friday.Text'] : "Friday"}
                                        </Col>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="6" defaultChecked={current_Day == 6 ? true : false} ref="recur_Saturday" /> {label['CreateTenant.Saturday.Text'] !== undefined ? label['CreateTenant.Saturday.Text'] : "Saturday"}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ size: 3 }}>
                                            <input type="checkbox" value="0" defaultChecked={current_Day == 0 ? true : false} ref="recur_Sunday" /> {label['CreateTenant.Sunday.Text'] !== undefined ? label['CreateTenant.Sunday.Text'] : "Sunday"}
                                        </Col>
                                        <Col sm={{ size: 3 }}>

                                        </Col>
                                        <Col sm={{ size: 3 }}>

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ size: 9 }}>
                                            <label>&nbsp;</label>
                                        </Col>
                                    </Row>

                                    <FormGroup>
                                        <label className="padding_Form_Left" style={{ color: '#323232' }}>{label['Requests.RepeatEnding.Text'] !== undefined ? label['Requests.RepeatEnding.Text'] : "Repeat Ending"}</label><br />
                                        <DatePicker className="bottomBorderTextBox" dateFormat="EEE MMM dd yyyy" minDate={this.state.startDate} selected={this.state.stopDate} onChange={this.handleStopDateChange} />
                                    </FormGroup>

                                </div>
                            </div>
                        )}

                    <FormGroup>
                        <label className="padding_Form_Left" style={{ color: '#323232' }}  >{label['Requests.EnterComments.Text'] !== undefined ? label['Requests.EnterComments.Text'] : "Enter Your Comments"}</label>
                        <input type="textarea" name="text" ref="Comments" disabled={this.state.IsInActiveRequest || l_IsPastRequest} defaultValue={l_Comments} className="tenat_form_control tenat_form_control_Addrequest_modal" />
                    </FormGroup>

                    {this.props.RequestId > 0 ?
                        <FormGroup>
                            <label className="padding_Form_Left" style={{ color: '#323232' }}>Created</label>
                            <p>{this.state.request_created}</p>
                        </FormGroup> : ""
                    }

                    <FormGroup check row>
                        <Button type="button" className="btn btn-black" onClick={this.OnGetCaluculateCost} >{label['AfterHours.CalculateCost.Text'] !== undefined ? label['AfterHours.CalculateCost.Text'] : "CALCULATE COST"} </Button>
                    </FormGroup>
                    <FormGroup row className="btns_group">
                        <Button className="btn-gray btn-md" onClick={() => CloseModal()} > {label['Buttons.Cancel.Text']} </Button>

                        {l_IsPastRequest ? "" :
                        this.state.IsInActiveRequest == false ?
                            this.props.RequestId > 0 ? (
                                <Button className="btn-success btn-md" onClick={this.OnSaveRequest} > Update </Button>
                            ) : (<Button className="btn-success btn-md" onClick={this.OnSaveRequest} > {label['Buttons.Apply.Text']} </Button>) : ""
                        }

                    </FormGroup>
                </Form>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{ width: '600px', height: '270px' }} >
                    {Cost_in_input}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        Tenant_ZoneList_Response: state.ViewtenantsRootReducer,
        Tenant_Request_Cost: state.tenantsRootReducer,
        Request_Selected_Response: state.RequestRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        Tenant_List_Response: state.tenantsRootReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesListforTenant: (tenantID) => dispatch(GetZonesListforTenant(tenantID)),
        SaveRequest: (data) => dispatch(SaveRequest(data)),
        GetCalculateCost: (data) => dispatch(GetCalculateCost(data)),
        GetSelectedRequest: (id) => dispatch(GetSelectedRequest(id)),
        GetAllTenantList: () => dispatch(GetAllTenantList()),
        UpdateRequest: (data) => dispatch(UpdateRequest(data)),
        GetSelectedPastRequest: (id) => dispatch(GetSelectedPastRequest(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddRequest);

